import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Emerging Tech">
                <h1>Emerging Technology Solutions In IT</h1>
              </div>
              <p className="main_para">
                Embrace the next generation of technology which can provide
                benefits to companies that are looking to improve their
                operations, enhance their customer experience, or gain a
                competitive advantage.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                TekRevol delivers world-class enterprise emerging technology
                solution from artificial intelligence, machine learning, and
                blockchain to cybersecurity, automation, and metaverse.
              </p>
              <ul>
                <li>Blockchain Development</li>
                <li>Extended Reality</li>
                <li>
                  Machine Learning, Artificial Intelligence, and Deep Learning
                </li>
                <li>Intelligence Automation Consulting</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
